// State key constants used to key state stored per user session.
// Historically declared inside StatefulSettings; extracted here to keep
// StatefulSettings focused on behaviour rather than configuration data.

export const STATE_KEY_FAVOURITE_ITEMS = "favourites";
export const STATE_KEY_CREDITS = "credits";
export const STATE_KEY_PERMISSIONS = "permissions";
export const STATE_KEY_POSITIONS = "positions";
export const STATE_KEY_METRONOME = "metronome";
export const STATE_KEY_SITE_EFFECTS = "siteEffects";
export const STATE_KEY_SCHEDULER = "scheduler";
export const STATE_KEY_REPORTCOMPLETE = "reportComplete";
export const STATE_KEY_MORNINGREPORT = "morningReportRequest";
export const STATE_KEY_DAILYREPORT = "dailyReportRequest";
export const STATE_KEY_LAST_RUN_DATES = "lastrunDate";
export const STATE_KEY_PREVIOUS_ITEM_SELECTIONS = "itemHistory";
export const STATE_KEY_HISTORY_CREDITS = "creditHistory";
export const STATE_KEY_HISTORY_POSITIONS = "positionHistory";
export const STATE_KEY_HISTORY_PENALTIES = "penaltieHistory";
export const STATE_KEY_HISTORY_EVENTTASKS = "eventTaskHistory";
export const STATE_KEY_HISTORY_TASK_OPTIONS = "STATE_KEY_HISTORY_TASK_OPTIONS";
export const STATE_KEY_LINES_IN_PROGRESS = "STATE_KEY_LINES_IN_PROGRESS";
export const STATE_KEY_HISTORY_TASK_ITEMS_USED = "STATE_KEY_HISTORY_TASK_ITEMS_USED";
export const STATE_KEY_PROOF_REQUEST_CAPTURE = "ProofInProgress";
export const STATE_KEY_LINES = "linesInProgress";
export const STATE_KEY_ROULETTE = "STATE_KEY_ROULETTE";
export const STATE_KEY_REQUEST_LOCK = "STATE_KEY_REQUEST_LOCK";
export const STATE_KEY_WORK_DAYS = "workDays";
export const STATE_KEY_WEEKEND_DAYS = "weekendDays";
export const STATE_KEY_OVERRIDE_TIMES = "STATE_KEY_OVERRIDE_TIMES";
export const STATE_KEY_PREVIEW_DAYS = "previewDays";
export const STATE_KEY_PREVIEW_BASKET = "STATE_KEY_PREVIEW_BASKET";
export const STATE_KEY_UNAVAILABLE_DAYS = "unavailableDays";
export const STATE_KEY_HOLIDAYS = "holidays";
export const STATE_KEY_PROOF_REQUESTS = "proofRequests";
export const STATE_KEY_CURRENT_DAY = "currentDay";
export const STATE_KEY_ENABLE_SOUNDS = "enableSounds";
export const PREVIEW_EVENT_TASKS = "PREVIEW_EVENT_TASKS";
export const STATE_KEY_ACTIVE_SESSION_NAME = "activeSessionName";
export const STATE_KEY_LOCK_STATE = "lockState";
export const STATE_KEY_COMMUNITY_FILTERS = "communityFiltersState";
export const STATE_KEY_SESSION_VIEW = "sessionViewState";
export const STATE_KEY_LAST_HYGIENE = "lastHygiene";
export const STATE_KEY_SUMMARY_TEXT_FLAGS = "STATE_KEY_SUMMARY_TEXT_FLAGS";
export const STATE_KEY_LAST_LEAST_USED_CHECK = "STATE_KEY_LAST_LEAST_USED_CHECK";
export const STATE_KEY_TOUR_STATE = "STATE_KEY_TOUR_STATE";
export const STATE_KEY_CUSTOM_DAY = "STATE_KEY_CUSTOM_DAY";
